import { defineRoutes } from '#utils';

export const routes = defineRoutes({
  personnel: {
    find: '/personnel',
    memberships: {
      batch: {
        create: '/personnel/memberships/batch',
        remove: '/personnel/memberships/batch',
      },
    },
    update: (id: string) => `/personnel/${id}`,
  },
});
